// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"82ab4751","640":"2c8322ef"}[chunkId] + ".chunk.js";
};